import { inject } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CASH_REGISTER_CART_CATEGORIES,
  SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_IMAGE,
  SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_PRODUCTS,
  SOFTLINE_API_CASH_REGISTER_CART_PRODUCT_IMAGE,
} from '../main.api';
import { lastValueFrom } from 'rxjs';
import { CartItem, Category } from '@softapps/wws/pos-core';

export interface IProductRepository {
  loadCategories(): Promise<Category[]>;
  loadCategoryImageById(categoryId: number): Promise<string>;
  loadProductsByCategoryId(categoryId: number): Promise<CartItem[]>;
  loadProductImageById(productId: number): Promise<string>;
}

export class ProductRepository implements IProductRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async loadCategories(returnable = false): Promise<Category[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CART_CATEGORIES,
      queryParams: { returnable },
    });
  }

  async loadCategoryImageById(categoryId: number): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download({
        path: SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_IMAGE,
        pathParams: { categoryId },
      })
    );

    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }

  async loadProductsByCategoryId(
    categoryId: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- contract param, backend does not take a filter yet
    returnableProducts?: boolean
  ): Promise<CartItem[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CART_CATEGORY_PRODUCTS,
      pathParams: { categoryId },
    });
  }

  async loadProductImageById(productId: number): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download({
        path: SOFTLINE_API_CASH_REGISTER_CART_PRODUCT_IMAGE,
        pathParams: { productId },
      })
    );

    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }
}
